//i18n
import Vue from "vue"
import VueI18n from "vue-i18n"
import enUS from "./en-US.json"
import zhHK from "./zh-HK.json"
import zhCN from "./zh-CN.json"
import VeeValidate from "vee-validate"
import initCustomRules from "@/utils/initCustomRules"

Vue.use(VueI18n)
let locale = "en-US"
let messages = {
	"en-US": enUS
}
// HACK: Since we changed default locale from en to en-US
// we have to check if previous user still have 'en' setup in their browser
if (window.localStorage["covergo-locale"] === "en")
	window.localStorage["covergo-locale"] = "en-US"

if (window.localStorage["covergo-locale"]) {
	locale = window.localStorage["covergo-locale"]
	messages = {
		[locale]: locale === "zh-CN" ? zhCN : locale === "zh-HK" ? zhHK : enUS
	}
}
export const i18n = new VueI18n({
	locale,
	fallbackLocale: "en-US",
	messages
})

// vee-validate
initCustomRules()
VeeValidate.Validator.localize("en-US", enUS.veeValidate)
Vue.use(VeeValidate)

// Array of loaded languages
const loadedLanguages = [locale] // Our default language that is preloaded

// Set locale
function setI18nLanguage(lang, msgs) {
	i18n.locale = lang
	window.localStorage.setItem("covergo-locale", lang)
	VeeValidate.Validator.localize(lang, msgs ? msgs.default.veeValidate : null)
	return lang
}

// Fetch dictionary
export function loadLanguageAsync(lang) {
	if (i18n.locale !== lang) {
		if (!loadedLanguages.includes(lang)) {
			return import(
				/* webpackChunkName: "lang-[request]" */ `@/locales/${lang}.json`
			).then(msgs => {
				i18n.setLocaleMessage(lang, msgs.default)
				loadedLanguages.push(lang)
				return setI18nLanguage(lang, msgs)
			})
		}
		return Promise.resolve(setI18nLanguage(lang))
	}
	return Promise.resolve(lang)
}
